import React from 'react';

const CourageIcon = () => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1633_1359)">
      <path
        d="M22.5071 20H4.3372C4.16153 20 4.00357 19.9093 3.91369 19.7567C3.82381 19.6042 3.82109 19.42 3.90552 19.2647L12.9911 2.57027C13.0769 2.41083 13.2431 2.31324 13.4214 2.31324C13.6012 2.31324 13.766 2.41221 13.8531 2.57027L22.9374 19.2647C23.0218 19.42 23.0191 19.6042 22.9292 19.7567C22.8393 19.9093 22.6814 20 22.5057 20H22.5071ZM4.37941 19.4791H22.4662L13.4228 2.86028L4.37941 19.4777V19.4791Z"
        fill="#0A3887"
      />
      <path
        d="M10.2022 20H0.385351C0.247814 20 0.123895 19.9285 0.0544455 19.8089C-0.0150039 19.6894 -0.0177274 19.5464 0.0489985 19.4241L4.95676 10.4048C5.02484 10.2811 5.15285 10.2041 5.29311 10.2041C5.43337 10.2041 5.56274 10.2811 5.62946 10.4062L10.5372 19.4255C10.6039 19.5464 10.6012 19.6907 10.5318 19.8103C10.4623 19.9299 10.3384 20.0014 10.2009 20.0014L10.2022 20ZM0.608679 19.4791H9.9789L5.29311 10.8694L0.608679 19.4777V19.4791Z"
        fill="#0A3887"
      />
      <path
        d="M5.34896 13.9111L3.58822 13.6513C3.44659 13.6307 3.34991 13.4974 3.37034 13.3558C3.39076 13.2128 3.52149 13.1152 3.66311 13.1359L5.23866 13.3682L6.50373 12.5778C6.62493 12.5022 6.78425 12.5393 6.85915 12.663C6.93404 12.7854 6.89728 12.9462 6.77472 13.0218L5.35033 13.9111H5.34896Z"
        fill="#0A3887"
      />
      <path
        d="M10.0566 8.76366C9.95443 8.76366 9.85775 8.70181 9.8169 8.6001C9.76379 8.46677 9.82779 8.31421 9.95988 8.2606L12.2395 7.33146L14.2344 8.24273H16.7618C16.9048 8.24273 17.0206 8.35956 17.0206 8.50388C17.0206 8.6482 16.9048 8.76503 16.7618 8.76503H14.1241L12.2299 7.90049L10.156 8.74717C10.1247 8.75954 10.092 8.76641 10.0593 8.76641L10.0566 8.76366Z"
        fill="#0A3887"
      />
      <path
        d="M6.1279 6.56725C4.86828 6.56725 3.84424 5.53364 3.84424 4.26225C3.84424 2.99086 4.86828 1.95725 6.1279 1.95725C7.38752 1.95725 8.41156 2.99086 8.41156 4.26225C8.41156 5.53364 7.38752 6.56725 6.1279 6.56725ZM6.1279 2.47818C5.15288 2.47818 4.36034 3.27812 4.36034 4.26225C4.36034 5.24637 5.15288 6.04632 6.1279 6.04632C7.10291 6.04632 7.89545 5.24637 7.89545 4.26225C7.89545 3.27812 7.10291 2.47818 6.1279 2.47818Z"
        fill="#0A3887"
      />
      <path
        d="M13.4092 2.9565C13.2662 2.9565 13.1505 2.83967 13.1505 2.69535V0.30101C13.1505 0.134699 13.2839 0 13.4487 0H15.5226C15.6438 0 15.7514 0.0728472 15.7977 0.185554C15.844 0.298261 15.8181 0.426088 15.7337 0.51268L15.2312 1.01986L15.6765 1.46931C15.7609 1.55591 15.7868 1.68373 15.7419 1.79644C15.6969 1.90915 15.5894 1.98199 15.4695 1.98337L13.6693 2.00124V2.69535C13.6693 2.83967 13.5535 2.9565 13.4105 2.9565H13.4092ZM13.6679 0.520926V1.47894L14.9425 1.46657L14.711 1.2329C14.5953 1.1147 14.5953 0.925022 14.711 0.808192L14.9956 0.520926H13.6679Z"
        fill="#0A3887"
      />
    </g>
    <defs>
      <clipPath id="clip0_1633_1359">
        <rect width={23} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CourageIcon;
